(function (apiKey) {
  (function (p, e, n, d, o) {
    var v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = o._q || [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
    for (w = 0, x = v.length; w < x; ++w)
      (function (m) {
        o[m] =
          o[m] ||
          function () {
            o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
          };
      })(v[w]);
    y = e.createElement(n);
    y.async = !0;
    y.src = 'https://content.platform.insightia.com/agent/static/' + apiKey + '/pendo.js';
    y.integrity = 'sha384-T/TPNZOhTTZywpb6ZFtg9HqOvSUt9+2AuOT59UYCXbmu5HlqJkJJMjSSSFEJsaSD';
    y.crossOrigin = 'anonymous';
    z = e.getElementsByTagName(n)[0];
    y.onerror = function () {
      y.remove();
      var fallback = e.createElement(n);
      fallback.async = !0;
      fallback.src = 'https://content.platform.insightia.com/agent/static/' + apiKey + '/pendo.js';
      fallback.crossOrigin = 'anonymous';
      z.parentNode.insertBefore(fallback, z);
    };
    z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');
})('dd2b87d6-a637-44f0-51e2-97f36daa7958');
